import { Component, OnInit, inject } from '@angular/core';
import { SuggestionEngineService } from '../../../suggestion-engine/suggestion-engine.service';
import { Router } from '@angular/router';
import { ClientOpportunityResponse } from '../../../models/suggestion-engine-models';

@Component({
  selector: 'app-top-opps',
  templateUrl: './top-opps.component.html',
  styleUrls: ['./top-opps.component.scss'],
  standalone: false,
})
export class TopOppsComponent implements OnInit {
  private ses = inject(SuggestionEngineService);
  private router = inject(Router);

  opportunities: {
    id: string;
    name: string;
    suggestions: { Name: string; Relevance: string }[];
  }[] = [];
  state: string = 'loading';

  ngOnInit() {
    this.ses.getTopOpps().subscribe((x: ClientOpportunityResponse) => {
      if (
        x.ClientOpportunities.Clients &&
        x.ClientOpportunities.Clients.length
      ) {
        this.opportunities = x.ClientOpportunities.Clients.map(z => {
          return { id: z.id, name: z.Name, suggestions: z.Bridges };
        });
        this.state = 'loaded';
      } else if (!x.ClientOpportunities.Clients) {
        this.state = 'none';
      }
    });
  }

  goToProfile(ev, id) {
    this.router.navigate([`/se/client/${id}`]);
  }
}
